export default "__VITE_ASSET__DHwy3hha__"